import { DocumentGroupRelation } from '~/api/documentGroups';
import { DocumentSearchResultItem } from '~/redux/api/methods/search';

export const getHandlersKeyFromSearchResult = (doc: DocumentSearchResultItem) =>
  doc.document_handlers;

export const getHandlersKeyFromDocumentGroup = (doc: DocumentGroupRelation) =>
  doc.handlers;
